import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8765 15C12.7456 15 13.4938 14.3841 13.6637 13.5287L14.9648 6.97767C15.1036 6.27893 14.8253 5.56294 14.2518 5.14295L9.07424 1.35151C8.43423 0.882831 7.56578 0.88283 6.92576 1.35151L1.74822 5.14295C1.17469 5.56293 0.896445 6.27893 1.03522 6.97766L2.33627 13.5287C2.50615 14.3841 3.25435 15 4.12351 15L11.8765 15ZM9.48781 12.0713L11.9435 5.51174H10.3366C10.1605 5.51174 9.98846 5.56823 9.84259 5.67393C9.69671 5.77964 9.58373 5.92971 9.51818 6.10482L8.43902 8.98915L9.48781 12.0713ZM9.16846 12.7863H7.56237C7.38612 12.7863 7.21391 12.7298 7.06793 12.624C6.92194 12.5182 6.80887 12.368 6.74329 12.1927L4.24227 5.51223H5.8479C6.02436 5.51226 6.19677 5.56891 6.3429 5.67488C6.48903 5.78086 6.60217 5.9313 6.66775 6.1068L9.16846 12.7863Z"
      fill="url(#paint0_linear_4990_409)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4990_409"
        x1={12.6962}
        y1={16.4879}
        x2={3.19335}
        y2={0.225661}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#216FE3" />
        <stop offset={1} stopColor="#4891FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
